import Playground from 'components/Playground';
import Button from "components/Button";
import Fade from "components/Fade";
import * as React from 'react';
export default {
  Playground,
  Button,
  Fade,
  React
};